(function() { window.GUID_25b2c16e_985e_4fb0_8403_2f361c780174 = { getGuid: function() { return "25b2c16e-985e-4fb0-8403-2f361c780174"; } }; })();
var CS;
(function (CS) {
    var CookieConsent;
    (function (CookieConsent) {
        function bootstrap() {
            var _a;
            return (_a = window.CS) === null || _a === void 0 ? void 0 : _a.CookieConsentBootstrap;
        }
        function CanUseFunctionalPreferences() {
            var _a;
            const commonData = CS.CommonData.Current;
            if (commonData) {
                return commonData.IsFunctionalAppPreferenceAccepted === true;
            }
            return ((_a = bootstrap()) === null || _a === void 0 ? void 0 : _a.isFunctionalAppPreferenceAccepted) === true;
        }
        CookieConsent.CanUseFunctionalPreferences = CanUseFunctionalPreferences;
        function CanUseAppAnalytics() {
            var _a;
            const commonData = CS.CommonData.Current;
            if (commonData) {
                return commonData.IsAnalyticsAppAccepted === true;
            }
            return ((_a = bootstrap()) === null || _a === void 0 ? void 0 : _a.isAnalyticsAppAccepted) === true;
        }
        CookieConsent.CanUseAppAnalytics = CanUseAppAnalytics;
        function CanUseGoogleAdsCookies() {
            var _a;
            const commonData = CS.CommonData.Current;
            if (commonData) {
                return commonData.IsMarketingGoogleAccepted === true;
            }
            return ((_a = bootstrap()) === null || _a === void 0 ? void 0 : _a.isMarketingGoogleAccepted) === true;
        }
        CookieConsent.CanUseGoogleAdsCookies = CanUseGoogleAdsCookies;
        function ShouldRenderGoogleTagManagerNoScript() {
            return CanUseAppAnalytics() || CanUseGoogleAdsCookies();
        }
        CookieConsent.ShouldRenderGoogleTagManagerNoScript = ShouldRenderGoogleTagManagerNoScript;
        function CanUseMetaPixel() {
            var _a;
            const commonData = CS.CommonData.Current;
            if (commonData) {
                return commonData.IsAnalyticsMetaAccepted === true;
            }
            return ((_a = bootstrap()) === null || _a === void 0 ? void 0 : _a.isAnalyticsMetaAccepted) === true;
        }
        CookieConsent.CanUseMetaPixel = CanUseMetaPixel;
        function CanUseYoutubeEmbeds() {
            var _a;
            const commonData = CS.CommonData.Current;
            if (commonData) {
                return commonData.IsFunctionalYoutubeAccepted === true;
            }
            return ((_a = bootstrap()) === null || _a === void 0 ? void 0 : _a.isFunctionalYoutubeAccepted) === true;
        }
        CookieConsent.CanUseYoutubeEmbeds = CanUseYoutubeEmbeds;
        function ApplyUpdatedConsent(data) {
            var _a, _b;
            const functionalAppPreferenceAccepted = data.AcceptAll === true
                ? true
                : data.RejectAll === true
                    ? false
                    : data.IsFunctionalAppPreferenceAccepted === true;
            const analyticsAppAccepted = data.AcceptAll === true
                ? true
                : data.RejectAll === true
                    ? false
                    : data.IsAnalyticsAppAccepted === true;
            const marketingGoogleAccepted = data.AcceptAll === true
                ? true
                : data.RejectAll === true
                    ? false
                    : data.IsMarketingGoogleAccepted === true;
            const AnalyticsMetaAccepted = data.AcceptAll === true
                ? true
                : data.RejectAll === true
                    ? false
                    : data.IsAnalyticsMetaAccepted === true;
            const FunctionalYoutubeAccepted = data.AcceptAll === true
                ? true
                : data.RejectAll === true
                    ? false
                    : data.IsFunctionalYoutubeAccepted === true;
            if (CS.CommonData.Current) {
                CS.CommonData.Current.IsFunctionalAppPreferenceAccepted = functionalAppPreferenceAccepted;
                CS.CommonData.Current.IsAnalyticsAppAccepted = analyticsAppAccepted;
                CS.CommonData.Current.IsMarketingGoogleAccepted = marketingGoogleAccepted;
                CS.CommonData.Current.IsAnalyticsMetaAccepted = AnalyticsMetaAccepted;
                CS.CommonData.Current.IsFunctionalYoutubeAccepted = FunctionalYoutubeAccepted;
            }
            const consentBootstrap = bootstrap();
            if (consentBootstrap) {
                consentBootstrap.isFunctionalAppPreferenceAccepted = functionalAppPreferenceAccepted;
                consentBootstrap.isAnalyticsAppAccepted = analyticsAppAccepted;
                consentBootstrap.isMarketingGoogleAccepted = marketingGoogleAccepted;
                consentBootstrap.isAnalyticsMetaAccepted = AnalyticsMetaAccepted;
                consentBootstrap.isFunctionalYoutubeAccepted = FunctionalYoutubeAccepted;
            }
            if (!functionalAppPreferenceAccepted) {
                CS.Cookie.RemoveCookie(CS.Cookie.Names.Features.PricingUpdate);
            }
            if (!AnalyticsMetaAccepted) {
                document.cookie = "_fbp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax";
            }
            else {
                (_b = (_a = window.Facebook) === null || _a === void 0 ? void 0 : _a.EnsureSdkLoaded) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
            window.adsbygoogle = window.adsbygoogle || [];
            window.adsbygoogle.requestNonPersonalizedAds = marketingGoogleAccepted ? 0 : 1;
            if (typeof window.gtag === "function") {
                window.gtag("consent", "update", {
                    analytics_storage: analyticsAppAccepted ? "granted" : "denied",
                    ad_storage: marketingGoogleAccepted ? "granted" : "denied",
                    ad_user_data: marketingGoogleAccepted ? "granted" : "denied",
                    ad_personalization: marketingGoogleAccepted ? "granted" : "denied",
                    functionality_storage: functionalAppPreferenceAccepted ? "granted" : "denied",
                    security_storage: "granted",
                });
            }
        }
        CookieConsent.ApplyUpdatedConsent = ApplyUpdatedConsent;
    })(CookieConsent = CS.CookieConsent || (CS.CookieConsent = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-cookie-consent.js.map
